module.exports = __webpack_public_path__ + "img/bebeoso.2f9d2e34.jpg";